import type { NostrEvent } from "@nostr/tools";

export function getTitle(event: NostrEvent): string {
  return event.tags.find((t) => t[0] === "title")?.[1] || event.id;
}

export function formatDate(timestamp: number): string {
  const date = new Date(timestamp * 1000);
  const now = new Date();
  const diff = now.getTime() - date.getTime();

  // if less than 24 hours ago, show relative time
  if (diff < 24 * 60 * 60 * 1000) {
    const hours = Math.floor(diff / (60 * 60 * 1000));
    if (hours < 1) {
      const minutes = Math.floor(diff / (60 * 1000));
      return `${minutes} minute${minutes !== 1 ? "s" : ""} ago`;
    }
    return `${hours} hour${hours !== 1 ? "s" : ""} ago`;
  }

  // otherwise show formatted date
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: date.getFullYear() !== now.getFullYear() ? "numeric" : undefined
  });
}

export function getBasePath(): string {
  const meta = document.head.querySelector('meta[name="base-path"]');
  const base = meta?.getAttribute("content");
  if (!base) return "";
  if (base.endsWith("/")) return base.substring(0, base.length - 1);
  return base;
}
